<template>
  <div>
    <div class="level">
      <div class="level-left">
        <span v-if="!hasTechnicalPrivOnly">
          <router-link
            class="button is-info is-small"
            :to="{ name: 'Create Ticketing for Item' }"
          >
            <span class="icon"> <i class="fas fa-plus"></i> </span>&nbsp; Create
            new</router-link
          >
          &nbsp;
        </span>
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-button
          @click="sortByStatusCount('all')"
          rounded
          :loading="isFetchingTotalCountOfStatus"
          >All ({{ totalStatus.all }})</b-button
        >
        &nbsp;
        <b-button
          alt="Pending"
          @click="sortByStatusCount(0)"
          rounded
          :loading="isFetchingTotalCountOfStatus"
          style="background-color:#E08A1E;color:white"
          >{{ totalStatus.pending }}</b-button
        >
        &nbsp;
        <b-button
          alt="In Progress"
          @click="sortByStatusCount(1)"
          rounded
          :loading="isFetchingTotalCountOfStatus"
          style="background-color:#22A7F0;color:white"
          >{{ totalStatus.inProgress }}</b-button
        >
        &nbsp;
        <b-button
          alt="Completed"
          @click="sortByStatusCount(2)"
          rounded
          :loading="isFetchingTotalCountOfStatus"
          style="background-color:#26C281;color:white"
          >{{ totalStatus.completed }}</b-button
        >
        &nbsp;
        <b-button
          alt="Canceled"
          @click="sortByStatusCount(3)"
          rounded
          :loading="isFetchingTotalCountOfStatus"
          style="background-color:#C91F37;color:white"
          >{{ totalStatus.canceled }}</b-button
        >
      </div>
    </div>

    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <b-select size="is-small" v-model="sow" title="Scope of work">
          <option value="all">All</option>
          <option value="0">Assemble only</option>
          <option value="1">Assemble & install</option>
          <option value="2">Install only</option>
          <option value="3">Repair/Troubleshoot</option>
          <option value="4">On-site scheduled service</option>
          <option value="5">Check/Diagnose</option>
        </b-select>
        &nbsp;
        <b-select size="is-small" v-model="itemType" title="Item type">
          <option value="all">All</option>
          <option value="0">Desktop pc</option>
          <option value="1">Laptop</option>
          <option value="2">Server</option>
        </b-select>
        &nbsp;
        <b-select
          size="is-small"
          v-model="progressStat"
          title="Progress status"
        >
          <option value="all">All</option>
          <option value="0">Pending</option>
          <option value="1">In progress</option>
          <option value="2">Completed</option>
          <option value="3">Canceled</option>
        </b-select>
        &nbsp;
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="ticketingForItems.data"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :search="search"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="ticketingForItems.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column class="table-column-content-is-small" label="Ticket Id">
          {{ item.row.ticketingForItemId }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Client">
          {{ item.row.client }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Agent">
          {{ item.row.user }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Scope & Item type"
        >
          {{ item.row.ticketingSow }} -
          <i>{{ item.row.ticketingItemType }}</i>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Assigned">
          {{ item.row.assignedUser }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Date created"
        >
          {{ item.row.dateCreated }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Last modified"
        >
          {{ item.row.lastModified }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Status">
          <center>
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#E08A1E;color:white"
              v-if="item.row.progressStatus == 'Pending'"
            >
              {{ item.row.progressStatus }}
            </b-tag>
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#22A7F0;color:white"
              v-if="item.row.progressStatus == 'In progress'"
            >
              {{ item.row.progressStatus }}
            </b-tag>
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#C91F37;color:white"
              v-if="item.row.progressStatus == 'Canceled'"
            >
              {{ item.row.progressStatus }}
            </b-tag>
            <b-tag
              size="is-small"
              style="font-size:9px;background-color:#26C281;color:white"
              v-if="item.row.progressStatus == 'Completed'"
            >
              {{ item.row.progressStatus }}
            </b-tag>
          </center>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button class="button is-small" @click="viewLog(item.row.ticketingForItemId)"><i class="fas fa-history"></i>&nbsp;Log</button>
          &nbsp;
          <router-link
            class="button is-small is-warning"
            :to="{
              name: 'Edit Ticketing for Item',
              params: { ticketingForItemId: item.row.ticketingForItemId }
            }"
            >View</router-link
          >
          <span v-if="!hasTechnicalPrivOnly">
            &nbsp;
            <button
              class="button is-small is-danger"
              @click="deleteData(item.row.ticketingForItemId)"
            >
              Delete
            </button>
          </span>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
    <Log />
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import Delete from "./Delete.vue";
import Log from "./Log";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
const signalR = require("@aspnet/signalr");
import ApiInfo from "../../_services/apiInfo";
import AuthService from "../../_services/auth";
import { WholeNumberWithComma } from "../../helpers/numeralFormat";

const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();

const apiInfo = new ApiInfo();

export default {
  components: {
    TablePagination,
    Delete,
    Log
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("ticketingforitem", {
      ticketingForItems: state => state.ticketingForItems,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: "",
    sow: "all",
    itemType: "all",
    progressStat: "all",
    // signalr
    name: "",
    message: "",
    connection: "",
    messages: "",
    apiHostAndPort: "",
    hasTechnicalPrivOnly: authService.hasTechnicalPrivOnly(),
    // total count of statuses
    isFetchingTotalCountOfStatus: true,
    totalStatus: {
      all: 0,
      pending: 0,
      inProgress: 0,
      completed: 0,
      canceled: 0
    }
  }),
  created() {
    this.getDataByRoute();
    apiInfo.hostAndPort().then(response => {
      this.apiHostAndPort = response;
    });
  },
  mounted() {
    apiInfo.hostAndPort().then(response => {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${response}hub/main`)
        .configureLogging(signalR.LogLevel.Information)
        .build();
      this.connection.start().catch(error => {
        console.log(error);
      });

      this.connection.on("ReceiveUpdateInTicketingForItem", () => {
        this.getDataByRoute();
      });
    });
  },
  methods: {
    ...mapActions("ticketingforitem", [
      "getPaginatedData",
      "openDeleteModal",
      "openLogModal"
    ]),
    refreshTable() {
      this.default();
    },
    sortByStatusCount(status) {
      this.progressStat = status;
      this.navToListWithParams();
    },
    getDataByRoute() {
      const pageFromRoute = parseInt(this.$route.params.page);
      const perPageFromRoute = parseInt(this.$route.params.pageSize);
      const searchQueryFromRoute = this.$route.params.searchQuery;
      const bySowFromRoute = this.$route.params.sow;
      const byItemTypeFromRoute = this.$route.params.itemType;
      const byProgressStatFromRoute = this.$route.params.progressStat;

      this.page = pageFromRoute ? pageFromRoute : 1;
      this.perPage = perPageFromRoute ? perPageFromRoute : 10;
      this.search = searchQueryFromRoute ? searchQueryFromRoute : "";
      this.sow = bySowFromRoute ? bySowFromRoute : "all";
      this.itemType = byItemTypeFromRoute ? byItemTypeFromRoute : "all";
      this.progressStat = byProgressStatFromRoute
        ? byProgressStatFromRoute
        : "all";

      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        sow: this.sow,
        itemType: this.itemType,
        progressStat: this.progressStat
      });

      this.getTotalCountOfStatus();
    },
    viewLog(id) {
      this.openLogModal({
        showLogModal: true,
        ticketingForItemId: id
      });
    },
    default() {
      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        sow: this.sow,
        itemType: this.itemType,
        progressStat: this.progressStat
      });
    },
    deleteData(id) {
      this.openDeleteModal({
        showDeleteModal: true,
        ticketingForItem: {
          ticketingForItemId: id
        }
      });
    },
    getTotalCountOfStatus() {
      this.isFetchingTotalCountOfStatus = true;
      axios
        .get(`api/ticketingforitems/get-total-count-of-status/`)
        .then(response => {
          this.totalStatus.all = WholeNumberWithComma(response.data.all);
          this.totalStatus.pending = WholeNumberWithComma(
            response.data.pending
          );
          this.totalStatus.inProgress = WholeNumberWithComma(
            response.data.inProgress
          );
          this.totalStatus.completed = WholeNumberWithComma(
            response.data.completed
          );
          this.totalStatus.canceled = WholeNumberWithComma(
            response.data.canceled
          );
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.isFetchingTotalCountOfStatus = false;
        });
    },
    navToListWithParams() {
      let progressStatCon = "all";

      if (!this.progressStat) {
        if (this.progressStat == 0) {
          progressStatCon = 0;
        }
      } else {
        progressStatCon = this.progressStat;
      }

      this.$router.push({
        name: "List of Ticketing for Item",
        params: {
          page: parseInt(!this.page ? 1 : this.page),
          pageSize: !this.perPage ? 10 : this.perPage,
          searchQuery: !this.search ? null : this.search,
          sow: !this.sow ? "all" : this.sow,
          itemType: !this.itemType ? "all" : this.itemType,
          progressStat: progressStatCon
        }
      });

      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        sow: this.sow,
        itemType: this.itemType,
        progressStat: progressStatCon
      });
    }
  },
  watch: {
    sow() {
      this.navToListWithParams();
    },
    itemType() {
      this.navToListWithParams();
    },
    progressStat() {
      this.navToListWithParams();
    },
    perPage(val) {
      this.navToListWithParams();
    },
    page(val) {
      this.navToListWithParams();
    },
    search(val) {
      this.navToListWithParams();
    }
  }
};
</script>
